import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";
import AOS from "aos";

export default function initObjectsTable() {
  const isPresent = document.querySelector(".objects-table");
  if (!isPresent) {
    return;
  }

  $(document).ready(function () {
    const table = $(".objects-table").DataTable({
      paging: false,
      // searching: false,
      stateSave: true,
      // scrollX: true,
      // scrollY: false,
      aoColumnDefs: [
        { sType: "num", aTargets: [2], orderSequence: ["asc", "desc"] },
      ],
      order: [
        [1, "desc"],
        [2, "asc"],
      ],
      // aoColumnDefs: [{ iDataSort: 0, aTargets: [1] }],
      drawCallback: function (settings) {
        function initDesktopFunctions() {
          const lrgScreens = window.matchMedia("(min-width: 768px)");

          lrgScreens.addListener(handleScreenChange);

          function handleScreenChange(e) {
            if (e.matches) {
              triggerObjectsOnImage();
            }
          }

          // Run it initially
          handleScreenChange(lrgScreens);
        }

        initDesktopFunctions();
      },
    });

    // Add this after your DataTable initialization
    table.on("draw", function () {
      AOS.refresh();
    });

    table.columns([0]).visible(false, false); // hide ID field

    const mqBelow768 = window.matchMedia("(max-width: 767px)");
    const mqBetween1024and1150 = window.matchMedia("(min-width: 1024px) and (max-width: 1150px)");
    function toggleMajaColumn() {
      const hide = mqBelow768.matches || mqBetween1024and1150.matches;
      table.column(1).visible(!hide, false);
      table.columns.adjust().draw(false);
    }
    mqBelow768.addEventListener("change", toggleMajaColumn);
    mqBetween1024and1150.addEventListener("change", toggleMajaColumn);
    toggleMajaColumn();

    table.on("click", "tbody tr", function () {
      // if apartment is not sold
      if (
        $(this).attr("data-status") !== "sold" &&
        $(this).attr("data-status") !== "reserved"
      ) {
        window.location.href = $(this).attr("data-url");
      }
    });

    // -----------------------------------------//
    function triggerObjectsOnImage() {
      const tableRows = document.querySelectorAll(".objects-table tbody tr");

      tableRows.forEach((row) => {
        $(row)
          .off("mouseenter")
          .on("mouseenter", function () {
            const rowID = row.dataset.id;
            document
              .querySelectorAll(`.buildings-svg-item[id='${rowID}']`)
              .forEach((el) => el.classList.add("active"));
          });
      });

      tableRows.forEach((row) => {
        $(row)
          .off("mouseleave")
          .on("mouseleave", function () {
            const rowID = row.dataset.id;
            document
              .querySelectorAll(`.buildings-svg-item[id='${rowID}']`)
              .forEach((el) => el.classList.remove("active"));
          });
      });
    }

    // FILTERS START
    generateFloorFilterValues();
    generateRoomsFilterValues();
    checkAllFilters();

    const clearFiltersBtn = document.querySelectorAll(".clear-filter");

    clearFiltersBtn.forEach((btn) => {
      const filter = btn.getAttribute("data-filter");

      btn.addEventListener("click", function () {
        table.columns(filter).search("").draw();

        clearInactiveFilters();
      });
    });

    function checkAllFilters() {
      const filterRadios = document.querySelectorAll(".clear-filter");

      filterRadios.forEach((radio) => {
        radio.querySelector("input").checked = true;
      });
    }

    // generate and update floor filter values
    function generateFloorFilterValues() {
      const floorsAll = [];
      table
        .column(3, { search: "applied" })
        .data()
        .each(function (value, index) {
          floorsAll.push(value);
        });

      const floors = [...new Set(floorsAll)].sort((a, b) => a - b);

      const list = document.querySelector(".floors-filter");

      list.innerHTML = "";
      floors.forEach(function (floor) {
        var div = document.createElement("div");
        div.innerHTML = `<input class="filter-item floor-filter" type="radio" id="floor-${floor}" name="floor" value="${floor}"><label for="floor-${floor}">${floor}</label>`;
        list.appendChild(div);
      });
    }

    // generate and update rooms filter values
    function generateRoomsFilterValues() {
      const roomsAll = [];
      table
        .column(4, { search: "applied" })
        .data()
        .each(function (value, index) {
          roomsAll.push(value);
        });

      const rooms = [...new Set(roomsAll)].sort((a, b) => a - b);

      const list = document.querySelector(".rooms-filter");

      list.innerHTML = "";
      rooms.forEach(function (room) {
        var div = document.createElement("div");
        div.innerHTML = `<input class="filter-item room-filter" type="radio" id="room-${room}" name="room" value="${room}"><label for="room-${room}">${room}</label>`;
        list.appendChild(div);
      });
    }

    function clearFloorFilter() {
      table.columns(3).search("").draw();
    }

    function clearRoomFilter() {
      table.columns(4).search("").draw();
    }

    function clearInactiveFilters() {
      const inactives = document.querySelectorAll(".filter-item");
      inactives.forEach((inactive) => {
        if (inactive.classList.contains("inactive")) {
          inactive.classList.remove("inactive");
        }
      });
    }

    function showActiveFloors() {
      var availFloors = [];
      table
        .column(3, { search: "applied" })
        .data()
        .each(function (value, index) {
          availFloors.push(value);
        });

      const floorFs = document.querySelectorAll(".floor-filter");

      floorFs.forEach((floorF) => {
        const inputValue = floorF.value;

        if (!availFloors.includes(inputValue)) {
          floorF.classList.add("inactive");
        } else {
          floorF.classList.remove("inactive");
        }
      });
    }

    function showActiveRooms() {
      var availRooms = [];
      table
        .column(4, { search: "applied" })
        .data()
        .each(function (value, index) {
          availRooms.push(value);
        });

      const roomFs = document.querySelectorAll(".room-filter");

      roomFs.forEach((roomF) => {
        const inputValue = roomF.value;

        if (!availRooms.includes(inputValue)) {
          roomF.classList.add("inactive");
        } else {
          roomF.classList.remove("inactive");
        }
      });
    }

    function filterFloor(floors) {
      table.columns(3).search(floors, true, false, false).draw(false);
      showActiveRooms();
      updateClearFiltersButton();
    }

    const floorsFilter = document.querySelector(".floors-filter");

    floorsFilter.addEventListener("click", function (e) {
      const item = e.target.closest("div");
      if (item) {
        filterFloor(item.querySelector("input").value);
      }
    });

    function filterRoom(rooms) {
      table.columns(4).search(rooms, true, false, false).draw(false);
      showActiveFloors();
      updateClearFiltersButton();
    }

    const roomsFilter = document.querySelector(".rooms-filter");

    roomsFilter.addEventListener("click", function (e) {
      const item = e.target.closest("div");
      if (item) {
        filterRoom(item.querySelector("input").value);
      }
    });

    // filter only available
    const availFilter = document.querySelector(".availability-filter");

    availFilter.addEventListener("click", function () {
      const input = availFilter.querySelector("input");
      if (input.checked) {
        const regExSearch = ".*\\d+.*";
        table.columns(8).search(regExSearch, true, false).draw();
      } else {
        table.columns(8).search("").draw();
      }

      filterFloor();
      filterRoom();
      updateClearFiltersButton();
    });

    // filter only balcony
    const balconyFilter = document.querySelector(".balcony-filter");

    balconyFilter.addEventListener("click", function () {
      const input = balconyFilter.querySelector("input");
      if (input.checked) {
        const regExSearch = ".*\\d+.*";
        table.column(6).search(regExSearch, true, false).draw();
      } else {
        table.columns(6).search("").draw();
      }

      filterFloor();
      filterRoom();
      updateClearFiltersButton();
    });

    // filter only terrace
    const terraceFilter = document.querySelector(".terrace-filter");

    terraceFilter.addEventListener("click", function () {
      const input = terraceFilter.querySelector("input");
      if (input.checked) {
        const regExSearch = ".*\\d+.*";
        table.column(7).search(regExSearch, true, false).draw();
      } else {
        table.columns(7).search("").draw();
      }

      filterFloor();
      filterRoom();
      updateClearFiltersButton();
    });

    // -----------------------------------------//

    // clear all filters exept selected building
    function clearAllFilters() {
      const clearBtns = document.querySelectorAll(".clear-all-table-filters");

      const balconyFilter = document
        .querySelector(".balcony-filter")
        .querySelector("input");
      const terraceFilter = document
        .querySelector(".terrace-filter")
        .querySelector("input");
      const availFilter = document
        .querySelector(".availability-filter")
        .querySelector("input");

      clearBtns.forEach((btn) => {
        btn.addEventListener("click", function () {
          clearFloorFilter();
          clearRoomFilter();

          checkAllFilters();

          balconyFilter.checked = false;
          table.columns(6).search("").draw();
          terraceFilter.checked = false;
          table.columns(7).search("").draw();
          availFilter.checked = false;
          table.columns(8).search("").draw();

          generateFloorFilterValues();
          generateRoomsFilterValues();
          updateClearFiltersButton();
        });
      });
    }

    clearAllFilters();

    function updateClearFiltersButton() {
      const clearFiltersButton = document.querySelector(
        ".clear-all-table-filters",
      );
      const filtersApplied = [
        table.column(3).search().trim() !== "", // Floor filter
        table.column(4).search().trim() !== "", // Room filter
        table.column(6).search().trim() !== "", // Balcony filter
        table.column(7).search().trim() !== "", // Terrace filter
        table.column(8).search().trim() !== "", // Availability filter
      ];

      const anyFilterApplied = filtersApplied.some((filter) => filter);

      // Toggle the hidden class
      if (anyFilterApplied) {
        clearFiltersButton.classList.remove("hidden");
      } else {
        clearFiltersButton.classList.add("hidden");
      }
    }

    // FILTERS END

    // -----------------------------------------//

    function triggerClickFromApartmentSVG() {
      const items = document.querySelectorAll(".buildings-svg-item");

      items.forEach((item) => {
        $(item).on("touchend click", function () {
          const id = item.getAttribute("id");
          const tableRow = document.querySelector(`tr[data-id=${id}]`);

          if (tableRow !== null) {
            tableRow.click();
          }
        });
      });
    }

    triggerClickFromApartmentSVG();

    // -----------------------------------------//

    // Highlight apartment on map when hovering over table row.
    function showApartmentMapHover() {
      $(".buildings-svg-item").on(
        "mouseenter mouseleave touchstart touchend",
        function () {
          var id = $(this).attr("id");

          $(".objects-table tr[data-id='" + id + "']").toggleClass(
            "tablehover",
          );
          $(".buildings-svg-item[id='" + id + "']")
            .not(this)
            .toggleClass("active");
        },
      );
    }

    showApartmentMapHover();
  });
}
